export default {
  items: state => state.items,
  pagination: state => state.pagination,
};
